<template>
    <div>
        <el-table :data="globalData.nominateStudents" border style="width: 100%;">
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="userName" label="姓名"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="grade" label="年级"></el-table-column>
          <el-table-column prop="title" label="作品标题"></el-table-column>
          <el-table-column prop="type" label="作品类别"></el-table-column>
        </el-table>
        <div style="margin:20px 10px;">
          <b>推荐评语：</b>{{globalData.remark}}
        </div>
    </div>
    
</template>

<script>
let that
export default {
    
    data(){
        return {
            list:[]
        }
    },
    
    methods: {
        handleConfirm() {
            that.$dialog.close('nominateStudentList')
        },
        handleClick(){
            console.log('click',that.form)
        },
    },
    mounted(){
      that = this
    }   
}
</script>

